import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiResponse, GenericItemApiResponse, GenericListApiResponse } from '../_interface/apiResponse';
import { Customer, CustomerAddress } from '../_interface/order';
import { map } from 'rxjs';
import { ProductPrice } from '../_interface/product';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {


  constructor(private http: HttpClient) { }


  setPriceList(customerID: number, priceListName: string) {
    const url = environment.apiBase + `customer/setPriceList`;
    var data = {
      customerID: customerID,
      priceListName: priceListName
    };

    return this.http.post<ApiResponse>(url, data)
      .pipe(
        map(response => {
          if (response.success) {
            return;
          }
          throw response.errorDescription;
        }),
      );
  }


  get(companyID: number, searchTerm: string, isVIP?: boolean) {
    const url = environment.apiBase + `customer/get`;
    var data = {
      companyID: companyID,
      name: searchTerm,
      isVIP: isVIP,
    };

    return this.http.post<GenericListApiResponse<Customer>>(url, data)
      .pipe(
        map(response => {
          if (response.success) {
            return response.items;
          }
          throw (response);
        })
      );
  }

  /** Spojene adrese dostave kupca (org-managed editabilne + account-global read-only) — za konobar delivery formu. */
  getAddresses(companyID: number, customerID: number) {
    const url = environment.apiBase + `customer/addresses/${companyID}/${customerID}`;
    return this.http.get<GenericListApiResponse<CustomerAddress>>(url)
      .pipe(
        map(response => {
          if (response.success) {
            return response.items;
          }
          throw (response);
        })
      );
  }

  /** Dodaje/menja org adresu kupca (dedup + LRU na serveru). Vraća upisanu adresu. */
  saveAddress(companyID: number, customerID: number, address: CustomerAddress) {
    const url = environment.apiBase + `customer/saveAddress`;
    return this.http.post<GenericItemApiResponse<CustomerAddress>>(url, { companyID, customerID, address })
      .pipe(
        map(response => {
          if (response.success) {
            return response.item;
          }
          throw (response);
        })
      );
  }

  /** Briše org adresu kupca (samo org-managed; account adrese se ne diraju). */
  deleteAddress(companyID: number, customerID: number, customerAddressID: number) {
    const url = environment.apiBase + `customer/deleteAddress`;
    return this.http.post<ApiResponse>(url, { companyID, customerID, customerAddressID })
      .pipe(
        map(response => response.success)
      );
  }

  getProductPrices(companyID: number, userID: number) {
    const url = environment.apiBase + `customer/productPrices/${companyID}/${userID}`;
    return this.http.get<GenericListApiResponse<ProductPrice>>(url)
      .pipe(
        map(response => {
          if (response.success) {
            return response.items;
          }
          throw (response);
        })
      );
  }

  saveProductPrices(companyID: number, userID: number, items: any[]) {
    const url = environment.apiBase + `customer/saveProductPrices/${companyID}/${userID}`;
    return this.http.post<ApiResponse>(url, items)
      .pipe(
        map(response => {
          return response.success;
        })
      );
  }


  setBlocked(companyID: number, customerID: number, isBlocked: boolean) {
    const url = environment.apiBase + `customer/setBlocked`;
    var data = {
      companyID: companyID,
      customerID: customerID,
      isBlocked: isBlocked
    };

    return this.http.post<ApiResponse>(url, data)
      .pipe(
        map(response => {
          return response.success;
        })
      );
  }

  saveCustomer(companyID: number, customer: Customer) {
    const url = environment.apiBase + `customer/save`;
    var data = {
      companyID,
      customer
    };
    return this.http.post<GenericItemApiResponse<Customer>>(url, data)
      .pipe(
        map(response => {
          if (response.success) {
            return response.item;
          }
          throw (response);
        })
      );
  }
}
